export const calculatorsData = [
    {
        "id": "gst-mrp",
        "name": "GST MRP Calculator",
        "description": "Calculate new MRP after GST Rate change",
        "category": "GST",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Gst_mrp_calculator/Gst_mrp_calculator.aspx"
    },
    {
        "id": "gst-rate",
        "name": "GST Rate Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "GST",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Gst_rate_calculator/Gst_rate_calculator.aspx"
    },
    {
        "id": "tds",
        "name": "TDS Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Tax",
        "originalUrl": "https://asrm.co.in/resources/Calculators/TDS_Calculator/TDSCalculator2026.aspx"
    },
    {
        "id": "income-tax",
        "name": "Income Tax Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Tax",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Tax_Calculator/cal_Income_Tax.aspx"
    },
    {
        "id": "effective-capital",
        "name": "Effective Capital Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Other",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Calculate_Effective_Capital/Calculate_Effective_Capital.aspx"
    },
    {
        "id": "net-profit",
        "name": "Net Profit Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Other",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Calculate_Net_Profit/Calculate_Net_Profit.aspx"
    },
    {
        "id": "net-worth",
        "name": "Net Worth Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Other",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Calculate_Net_Worth/Calculate_Net_Worth.aspx"
    },
    {
        "id": "gst-general",
        "name": "General GST Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "GST",
        "originalUrl": "https://asrm.co.in/resources/Calculators/GST_CALCULATOR/GST_CALCULATOR.aspx"
    },
    {
        "id": "hra",
        "name": "HRA Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Tax",
        "originalUrl": "https://asrm.co.in/resources/Calculators/HRA/HRA.aspx"
    },
    {
        "id": "nsc",
        "name": "NSC Calculator",
        "description": "Please Select: National Saving Certificates (VIII Issue) National Saving Certificates (IX Issue)",
        "category": "Other",
        "originalUrl": "https://asrm.co.in/resources/Calculators/NSC/Cal_NSC.aspx"
    },
    {
        "id": "auto-loan",
        "name": "Auto Loan Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Loan",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Auto_Loan_Calculator/AutoLoan.aspx"
    },
    {
        "id": "emi",
        "name": "EMI Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Loan",
        "originalUrl": "https://asrm.co.in/resources/Calculators/EMI/EMI.aspx"
    },
    {
        "id": "home-loan",
        "name": "Home Loan Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Loan",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Home_Loan_Calculator/HomeLoanCalculator.aspx"
    },
    {
        "id": "rera-buyer-refund",
        "name": "Home Buyer Refund Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "RERA",
        "originalUrl": "https://asrm.co.in/resources/Calculators/RERA_Calculator/HomeBuyerRefund/HomeBuyerRefund.aspx"
    },
    {
        "id": "rera-developers",
        "name": "Developers Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "RERA",
        "originalUrl": "https://asrm.co.in/resources/Calculators/RERA_Calculator/Developers_Calculator/RERADEVELOPER.aspx"
    },
    {
        "id": "rera-buyer-delay",
        "name": "Home Buyer Delay Interest Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "RERA",
        "originalUrl": "https://asrm.co.in/resources/Calculators/RERA_Calculator/HomeBuyerDelayIntrest_Calculator/HomeBuyerDelayIntrest.aspx"
    },
    {
        "id": "installments",
        "name": "Number of Installments Calculator",
        "description": "Central Board of Excise & Customs",
        "category": "Loan",
        "originalUrl": "https://asrm.co.in/resources/Calculators/Get_No._Of_Instalment/Get_No_Of_Instalment.aspx"
    }
];
